import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';

const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "content-section__inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ContentSection",
  props: {
    id: {},
    colorMode: { default: "light" },
    isFullwidthInArticleWithToc: { type: Boolean }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: _ctx.id,
        class: normalizeClass([
          "content-section",
          `content-section--color-${_ctx.colorMode}`,
          {
            "theme-light": _ctx.colorMode === "light" || _ctx.colorMode === "white" || _ctx.colorMode === "transparent",
            "theme-dark": _ctx.colorMode === "dark" || _ctx.colorMode === "black" || _ctx.colorMode === "transparent-dark",
            "content-section--fullwidth": _ctx.isFullwidthInArticleWithToc
          }
        ])
      }, [
        createElementVNode("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "default")
        ])
      ], 10, _hoisted_1);
    };
  }
});

export { _sfc_main as default };
